import { useRef } from 'react';

import { useModal } from 'mui-modal-provider';

import { ShowModalOutput } from '@cast/design-system';
import { Organization } from '@cast/types';

import { CreatedOrganizationDialog } from './CreatedOrganizationDialog';
import { CreateOrganizationDialog } from './CreateOrganizationDialog';

type UseCreateOrganizationDialogOptions = {
  setOrganizationOptions?: { skipRedirect?: boolean };
  onOrganizationCreated?: () => void;
};

export const useCreateOrganizationDialog = (
  options?: UseCreateOrganizationDialogOptions
) => {
  const { showModal } = useModal();
  const createOrgModalRef = useRef<ShowModalOutput | null>(null);
  const createdOrgModalRef = useRef<ShowModalOutput | null>(null);

  const openModal = (enterpriseOrgId?: string) => {
    createOrgModalRef.current = showModal(CreateOrganizationDialog, {
      enterpriseOrgId,
      destroy: (organization?: Organization, isChild?: boolean) => {
        createOrgModalRef.current?.destroy();

        if (organization) {
          createdOrgModalRef.current = showModal(CreatedOrganizationDialog, {
            name: organization.name,
            orgId: organization.id,
            isChild: !!isChild,
            setOrganizationOptions: options?.setOrganizationOptions,
            destroy: () => {
              createdOrgModalRef.current?.destroy();
              options?.onOrganizationCreated?.();
            },
          });
        }
      },
    });
  };

  return { openModal };
};
